import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './kpi-row-scoreboard.types';
import * as constants from './kpi-row-scoreboard.constants';

export const kpiRowScoreboardReducer = generateResourceReducer<types.IKpiRowScoreboard>({
  STORE: constants.STORE_KPI_ROW_SCOREBOARD,
  CLEAR: constants.CLEAR_KPI_ROW_SCOREBOARD,
});
